import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Container } from '../../styled-components/components/Container';
import { H1 } from '../../styled-components/components/Heading';
import { RouterLink } from '../../styled-components/components/Link';
import { MaxWidth } from '../../styled-components/components/MaxWidth';
import { Page, PageSection } from '../../styled-components/components/Page';
import { Text } from '../../styled-components/components/Text';
import { VStack } from '../../styled-components/components/VStack';
import { TEXT_CONTENT_MAX_WIDTH } from '../../styled-components/layout/constants';

const MissingItemError = () => {
  const { t } = useTranslation('error');

  return (
    <Page>
      <PageSection>
        <Container>
          <MaxWidth $maxWidth={TEXT_CONTENT_MAX_WIDTH}>
            <VStack $spacing={2}>
              <H1 $margin="none">{t('weCanNotFindTheVehicle', { ns: 'error' })}</H1>
              <Text $size="large" $weight="bold">
                {t('presumablyTheCarHasBeenSoldOrRemoved', { ns: 'error' })}
              </Text>
              <Text>
                <Trans
                  i18nKey="error:seeSimilarCars"
                  values={{
                    linkText: t('seeSimilarCarsLinkText', { ns: 'error' }),
                  }}
                  components={[
                    <RouterLink
                      key="email-link"
                      to="/sok"
                      title={
                        t('seeSimilarCarsLinktitle', {
                          ns: 'error',
                        }) || ''
                      }
                    />,
                  ]}
                />
              </Text>
            </VStack>
          </MaxWidth>
        </Container>
      </PageSection>
    </Page>
  );
};

export default MissingItemError;
